import { useCallback } from "react";
import { ActionHookContext } from "./types";

export function useModalActions(context: ActionHookContext) {
  const { store } = context;

  const setShowFeedbackModal = useCallback(() => {
    store.setShowFeedbackModal();
  }, [store]);

  const hideFeedbackModal = useCallback(() => {
    store.hideFeedbackModal();
  }, [store]);

  const setShowFullSizeImage = useCallback(
    (show: boolean) => {
      store.setFullSizeImage(show);
    },
    [store]
  );

  const setShowCreditModal = useCallback(
    (show: boolean) => {
      if (show) {
        store.setShowCreditModal();
      } else {
        store.hideCreditModal();
      }
    },
    [store]
  );

  return {
    setShowFeedbackModal,
    hideFeedbackModal,
    setShowFullSizeImage,
    setShowCreditModal,
  };
}
